import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Button, Dropdown } from "react-bootstrap";
import { BrowserRouter as Router, Route, Link, Routes } from "react-router-dom";
import FeatureFlags from "../Components/FeatureFlags";
import { Home } from "../Components/Home";
import { TMC } from "../Components/TMC";
import { Currencies } from "../Components/TMC/Currencies/Currencies";
import { ErrorMessages } from "../Components/ErrorMessages/ErrorMessages";
import { Categories } from "../Components/TMC/Categories/Categories";
import { NewMessage } from "../Components/NewMessage/NewMessage";
import { NewPrivacyPolicy } from "../Components/NewPrivacyPolicy/NewPrivacyPolicy";
import { PrivacyPolicy } from "../Components/PrivacyPolicy/PrivacyPolicy";
import { EditPolicy } from "../Components/EditPolicy/EditPolicy";
import { Messages } from "../Components/Messages/Messages";
import { Message } from "../Components/Message/Message";
import { AutoLogout } from "../Components/AutoLogout/AutoLogout";
import { NewPushNotifiction } from "../Components/NewPushNotification/NewPushNotification";
import { PushNotificationEdit } from "../Components/PushNotificationEdit/PushNotificationEdit";
import { PushNotification } from "../Components/PushNotification/PushNotification";
import { styles } from "./styles";

const NavigationBar = ({ signOut }) => {
  return (
    <AutoLogout signOut={signOut}>
      <Router>
        <Navbar variant="dark" style={styles.navBar}>
          <Container>
            <Navbar.Brand as={Link} to={"/"}>
              Back Office
            </Navbar.Brand>
            <Nav className="me-auto">
              <div style={styles.linkContainer}>
                <Nav.Link as={Link} to={"/featureFlags"}>
                  App Config
                </Nav.Link>
              </div>
              {/* <Dropdown className="dropdown">
                <Dropdown.Toggle id="dropdown-basic" variant="link" style={styles.dropdownStyle}>
                  <Nav.Link as={Link} to={"/TMC"}>
                    TMC
                  </Nav.Link>
                </Dropdown.Toggle>
                <Dropdown.Menu variant="dark">
                  <Dropdown.Item>
                    <Nav.Link as={Link} to={"/currencies"}>
                      Currencies
                    </Nav.Link>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown> */}
              {/* <Nav.Link as={Link} to={"/errormessages"}>
                Errors Page
              </Nav.Link> */}
              <Dropdown className="dropdown">
                <Dropdown.Toggle
                  id="dropdown-basic"
                  variant="link"
                  style={styles.dropdownStyle}
                >
                  <Nav.Link as={Link} to={"/messages"}>
                    Messages
                  </Nav.Link>
                </Dropdown.Toggle>
                <Dropdown.Menu variant="dark">
                  <Dropdown.Item>
                    <Nav.Link as={Link} to={"/new-message"}>
                      New Message
                    </Nav.Link>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown className="dropdown">
                <Dropdown.Toggle
                  id="dropdown-basic"
                  variant="link"
                  style={styles.dropdownStyle}
                >
                  <Nav.Link as={Link} to={"/policy"}>
                    Privacy Policies
                  </Nav.Link>
                </Dropdown.Toggle>
                <Dropdown.Menu variant="dark">
                  <Dropdown.Item>
                    <Nav.Link as={Link} to={"/add-policy"}>
                      New Policy
                    </Nav.Link>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown className="dropdown">
                <Dropdown.Toggle
                  id="dropdown-basic"
                  variant="link"
                  style={styles.dropdownStyle}
                >
                  <Nav.Link as={Link} to={"/push-notification"}>
                    Push Notifications
                  </Nav.Link>
                </Dropdown.Toggle>
                <Dropdown.Menu variant="dark">
                  <Dropdown.Item>
                    <Nav.Link as={Link} to={"/new-notification"}>
                      New notification
                    </Nav.Link>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
            <Button onClick={signOut} variant="light">
              Sign Out
            </Button>
          </Container>
        </Navbar>
        <div className="page-container">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/featureflags" element={<FeatureFlags />} />
            <Route path="/TMC" element={<TMC />} />
            <Route path="/currencies" element={<Currencies />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/errormessages" element={<ErrorMessages />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/messages/:id" element={<Message />} />
            <Route path="/new-message" element={<NewMessage />} />
            <Route path="/add-policy" element={<NewPrivacyPolicy />} />
            <Route path="/policy" element={<PrivacyPolicy />} />
            <Route path="/policy/:id" element={<EditPolicy />} />
            <Route path="/new-notification" element={<NewPushNotifiction />} />
            <Route path="/push-notification" element={<PushNotification />} />
            <Route
              path="/push-notification/:id"
              element={<PushNotificationEdit />}
            />
          </Routes>
        </div>
      </Router>
    </AutoLogout>
  );
};

export default NavigationBar;
